module.exports = __webpack_public_path__ + "static/media/15e-04_ST-13-2015-1829x1372mm-oleo-sobre-madera.13b337ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15e/15e-04_ST-13-2015-1829x1372mm-oleo-sobre-madera.jpg
// module id = 173
// module chunks = 0